module.exports = __webpack_public_path__ + "static/media/arrow_right_alt.95b4390a.svg";